import { BrowserRouter, Routes, Route } from "react-router-dom";
import LoginPage from "./pages/LoginPage";
import RegisterPage from "./pages/RegisterPage";
import AuthPage from "./pages/AuthPage";
import Layout from "./shared/Layout.js";
import LayoutExternal from "./shared/LayoutExternal";
import MainPage from "./pages/MainPage";
import HomePage from "./pages/HomePage";
import UsersPage from "./pages/UsersPage";
import DestinosPages from "./pages/DestinosPages";
import ProveedoresPage from "./pages/ProveedoresPage";
import UsuariosProveedoresPages from "./pages/UsuariosProveedoresPage";
import DashboardProveedores from "./pages/proveedores/DashboardProveedores";
import AdminGuias from "./pages/proveedores/AdminGuias";
import EnviosUsuariosPage from "./pages/usuarios/EnviosUsuariosPage";
import EmbarquesPage from "./pages/usuarios/EmbarquesPage";
import EnviosProveedores from "./pages/proveedores/EnvíosProveedoresPage";
import RecoveryPass from "./pages/RecoveryPass";
import UnauthorizedPage from "./pages/UnauthorizedPage";
import RastreoEnvio from "./shared/components/RastreoEnvio";

const Router = () => {
  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route element={<LayoutExternal />}>
            <Route path="/" element={<LoginPage />}></Route>
            <Route path="/Auth" element={<AuthPage />}></Route>
            <Route path="/Registrarse" element={<RegisterPage />}></Route>
            <Route path="/Recuperar-Contrasenia/:id" element={<RecoveryPass />}></Route>
            <Route path="/Rastreo/:noGuia?" element={<RastreoEnvio />} />
          </Route>

          <Route element={<Layout />}>
            <Route path="/Usuarios">
              <Route path="Home" element={<HomePage />} />
              <Route path="Dashboard" element={<MainPage />} />
              <Route path="Usuarios" element={<UsersPage />} title='Usuarios' />
              <Route path="Destinos" element={<DestinosPages />} />
              <Route path="Proveedores" element={<ProveedoresPage />} />
              <Route path="Envios" element={<EnviosUsuariosPage />} />
              <Route path="Embarques" element={<EmbarquesPage />} />
              <Route path="AccessDenied" element={<UnauthorizedPage />} />
            </Route>
            <Route path="/Proveedores">
              <Route path="Home" element={<HomePage />} />
              <Route path="Dashboard" element={<DashboardProveedores />} />
              <Route path="Guias" element={<AdminGuias />} />
              <Route path="UsuariosProveedores" element={<UsuariosProveedoresPages />} />
              <Route path="Envios" element={<EnviosProveedores />} />
              <Route path="AccessDenied" element={<UnauthorizedPage />}
              />
            </Route>
          </Route>

          {/* <Route element={<LayoutProveedores/>} path="/Proveedores">
            <Route path="Dashboard" element={<DashboardProveedores />} />
            <Route path="Guias" element={<AdminGuias />} />
            <Route path="Envios" element={<EnviosProveedores />} />
          </Route> */}
        </Routes>
      </BrowserRouter>
    </>
  );
};
export default Router;
